export default __webpack_public_path__ + "static/media/115.02af8344.gif";